<div class="mb-4 flex items-center justify-between gap-4">
	<div class="text-base font-bold text-black">
		{{ isInstructor ? "Past Training List" : "Report Management" }}
	</div>
</div>
<div class="mb-4 flex flex-wrap items-start justify-between gap-x-4 gap-y-3">
	<div class="flex min-w-0 flex-1 flex-wrap items-center gap-3">
		<div class="w-full max-w-xs">
			<div class="relative">
				<mat-form-field appearance="outline" subscriptSizing="dynamic" class="form-field form-field-sm w-full">
					<input matInput [(ngModel)]="searchQuery" (input)="onSearch()" placeholder="Search" class="pr-10" />
					<img class="absolute right-1 top-1/2 w-3 -translate-y-1/2" src="/assets/icon_search.svg" alt="Search" />
				</mat-form-field>
			</div>
		</div>
		<div class="flex shrink-0 gap-2">
			@if (isGroupAdmin) {
				<div class="w-[220px]">
					<mat-form-field appearance="outline" subscriptSizing="dynamic" class="form-field form-field-sm w-full">
						<mat-select
							[(value)]="selectedAocIds"
							(selectionChange)="onAocFilterChanged($event.value)"
							placeholder="AOC"
							multiple
							hideSingleSelectionIndicator
						>
							@for (option of aocFilterOptions; track option.value) {
								<mat-option [value]="option.value">{{ option.label }}</mat-option>
							}
						</mat-select>
						<img class="absolute right-1 top-1/2 w-3 -translate-y-1/2" src="/assets/icon_filter.svg" alt="Filter" />
					</mat-form-field>
				</div>
			}
			<div class="w-[220px]">
				<mat-form-field appearance="outline" subscriptSizing="dynamic" class="form-field form-field-sm w-full">
					<mat-select
						(valueChange)="onFormTypeChanged($event)"
						[value]="formTypes"
						placeholder="Filter"
						multiple
						hideSingleSelectionIndicator
					>
						@for (option of filterOptions; track option) {
							<mat-option [value]="option.value">
								<span>{{ option.label }}</span>
							</mat-option>
						}
					</mat-select>
					<img class="absolute right-1 top-1/2 w-3 -translate-y-1/2" src="/assets/icon_filter.svg" alt="Filter" />
				</mat-form-field>
			</div>
		</div>
	</div>
	<app-cbta-daterange-filter
		class="ml-auto"
		[startDate]="startDate"
		[endDate]="endDate"
		[enabled]="dateFilterEnabled"
		(dateRangeSelected)="handleDateRangeChange($event)"
	></app-cbta-daterange-filter>
</div>

<div class="cbta-tbl report-tbl">
	<div class="columns">
		<div class="column col-12">
			<ngx-table
				[configuration]="configuration"
				[data]="forms"
				[noResultsTemplate]="noResultsTemplate"
				[columns]="columns"
				[pagination]="pagination"
				(event)="onTableChanged($event)"
			>
			</ngx-table>
		</div>

		<!-- <ng-template #cbTpl let-row let-rowIndex="rowIndex">
      <div class="pr-4">
        <mat-checkbox></mat-checkbox>
      </div>
    </ng-template> -->

		<ng-template #trainingNameTpl let-row let-rowIndex="rowIndex">
			<span class="font-bold">{{ row.name }}</span>
		</ng-template>

		<ng-template #aocTpl let-row let-rowIndex="rowIndex">
			<span class="font-bold">{{ row.aoc }}</span>
		</ng-template>

		<!-- <ng-template #statusTpl let-row let-rowIndex="rowIndex">
      <span class="cbta-status font-medium px-3 py-0.5 rounded text-xs">
        {{ row.version }}
      </span>
    </ng-template> -->
		<ng-template #formTypeTpl let-row let-rowIndex="rowIndex">
			<span class="font-bold">{{ row.formTypeLabel }}</span>
		</ng-template>

		<ng-template #dateTpl let-row let-rowIndex="rowIndex">
			<span class="text-violet">{{ formatDate(row.updatedDate) }}</span>
		</ng-template>

		<ng-template #actionTpl let-row let-rowIndex="rowIndex">
			<button
				[disabled]="!isOnline"
				class="aa-btn mx-auto"
				data-size="small"
				data-variant="secondary"
				(click)="view(row.id)"
			>
				View
			</button>
		</ng-template>

		<ng-template #noResultsTemplate>
			<td [attr.colspan]="columns.length" class="h-[180px] text-center">
				<span class="text-grey-40">No results found.</span>
			</td>
		</ng-template>
	</div>
</div>
